import { House } from "lucide-react";
import { RotateCcw } from "lucide-react";
import { ShieldCheck } from "lucide-react";
import { Hammer } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

export default class FeatureTwo extends React.Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    return (
      <>
        <section className="feature-two-sec">
          <div
            className="feature-two__bg"
            style={{
              backgroundImage:
                "url(" +
                publicUrl +
                "assets/images/backgrounds/benefits-v1-bg.jpg)",
            }}
          ></div>
          <div className="shape3 float-bob-y">
            <img
              src={publicUrl + "assets/images/shapes/feature-v2-shape1.png"}
              alt=""
            />
          </div>
          <div className="container">
            <div className="sec-title text-center">
              <div className="sec-title__tagline">
                <span className="left"></span>
                <h6>Our Feature</h6> <span className="right"></span>
              </div>
              <h2 className="sec-title__title">Why Choose Us</h2>
            </div>
            <div className="row">
              {/* Start Feature Two Single */}
              <div className="col-xl-3 col-lg-6 col-md-6">
                <div className="feature-two__single">
                  <div className="shape1"></div>
                  <div className="shape2"></div>
                  <div className="icon">
                    <Hammer size={48} />
                  </div>
                  <h3>
                    <Link to={`/`}>Expert Craftsmanship</Link>
                  </h3>
                  <p>
                    We deliver exceptional quality in every project, ensuring
                    precision and lasting beauty in every stone.
                  </p>
                </div>
              </div>
              {/* End Feature Two Single */}

              {/* Start Feature Two Single */}
              <div className="col-xl-3  col-lg-6 col-md-6">
                <div className="feature-two__single">
                  <div className="shape1"></div>
                  <div className="shape2"></div>
                  <div className="icon">
                    <House size={48} />
                  </div>
                  <h3>
                    <Link to={`/`}>Custom Stone Solutions</Link>
                  </h3>
                  <p>
                    From patios to fire features, we tailor our services to your
                    unique vision, creating spaces you'll love.
                  </p>
                </div>
              </div>
              {/* End Feature Two Single */}

              {/* Start Feature Two Single */}
              <div className="col-xl-3  col-lg-6 col-md-6">
                <div className="feature-two__single">
                  <div className="shape1"></div>
                  <div className="shape2"></div>
                  <div className="icon">
                    <RotateCcw size={48} />
                  </div>
                  <h3>
                    <Link to={`/`}>Restoration & Repair</Link>
                  </h3>
                  <p>
                    Preserve the beauty of your stone structures with our expert
                    restoration services, ensuring they stand the test of time.
                  </p>
                </div>
              </div>
              {/* End Feature Two Single */}

              {/* Start Feature Two Single */}
              <div className="col-xl-3  col-lg-6 col-md-6">
                <div className="feature-two__single">
                  <div className="shape1"></div>
                  <div className="shape2"></div>
                  <div className="icon">
                    <ShieldCheck size={48} />
                  </div>
                  <h3>
                    <Link to={`/`}>Reliable & <br/> Insured</Link>
                  </h3>
                  <p>
                    We are fully insured and committed to your satisfaction,
                    providing peace of mind throughout your project.
                  </p>
                </div>
              </div>
              {/* End Feature Two Single */}
            </div>
          </div>
        </section>
      </>
    );
  }
}
